module.exports = __webpack_public_path__ + "static/media/ec.2114fe6e.svg";